<template>
  <div :class="[$style.root, { [$style.small]: kind === 'small' }, { [$style.empty]: kind === 'empty' } ]">
    <h1
      v-if="kind !== 'empty'"
      :class="[$style.heading, { [$style.smallHeading]: kind === 'small' } ]">
      <slot />
    </h1>
  </div>
</template>
<script>
export default {
  name: 'Hero',
  props: {
    kind: {
      type: String,
      default: 'default',
    },
  },
};
</script>

<style lang="scss" module scoped>
@import '../styles/variables';
@import '../styles/mixins';
@import '../styles/helpers';

.root {
  min-height: 465px;
  background: url('/static/back-image.png') no-repeat center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;

  @include media('<=phone') {
    min-height: 336px;
  }
}

.small {
  min-height: 145px;
  padding-top: $header-height;

  @include media('<desktop') {
    padding-top: $header-height-mobile;
  }
}

.empty {
  background: $red-dark;
  height: $header-height;
  min-height: 0;

  @include media('<desktop') {
    height: $header-height-mobile;
  }
}

.heading {
  color: $white;
  font-size: 40px;
  font-weight: normal;
  line-height: 1.45;
  text-align: center;
  margin: 0;

  @include media('<=phone') {
    @include set-fz-lh(26, 36);
  }
}

.smallHeading {
  font-size: 32px;

  @include media('<=phone') {
    @include set-fz-lh(20, 26);
  }
}

em {
  display: inline-block;
  background-color: $blue-deep;
  vertical-align: middle;
  line-height: 1.2;
  padding: 0 0 6px 12px;
  margin-left: 5px;
  font-weight: 100;
  font-style: normal;

  &:last-child {
    margin-right: 5px;
    padding-right: 12px;
  }
}

em + em {
  margin-left: 0;
  padding-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Hero.vue